import * as signalR from "@microsoft/signalr";

function PitchAngleGenerationService(http, path) {
    let _http = http;
    let _path = path;
    let _hub = null;
    let _connected = false;

    async function connect(onProgressUpdate) {
        if (_connected) return;

        _hub = new signalR.HubConnectionBuilder()
            .withUrl("/hubs/pitchAngle")
            .withAutomaticReconnect()
            .build();

        // SignalR event listeners
        _hub.on("PitchAngleProgress", progress => onProgressUpdate?.(progress));
        _hub.on("PitchAngleStarted", progress => onProgressUpdate?.(progress));
        _hub.on("PitchAngleFinished", progress => onProgressUpdate?.(progress));
        _hub.on("PitchAngleCancelled", progress => onProgressUpdate?.(progress));

        await _hub.start();
        _connected = true;
    }

    async function start(interpolationCoefficient = 1) {
        if (!_connected) {
            console.warn("SignalR not connected. Call connect() first.");
        }
        await _http.put(_path, null, { params: { interpolationCoefficient } });
    }

    async function cancel() {
        if (!_connected) {
            console.warn("SignalR not connected. Call connect() first.");
        }
        await _http.delete(_path);
    }

    async function getProgress() {
        const response = await _http.get(`${_path}/status`);
        return response.data;
    }

    async function disconnect() {
        if (_hub) {
            await _hub.stop();
            _hub = null;
            _connected = false;
        }
    }

    return {
        connect,
        start,
        cancel,
        getProgress,
        disconnect
    };
}

export default PitchAngleGenerationService;